import { BreakpointObserver, MediaMatcher } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { CoreService } from 'src/app/services/core.service';
import { AppSettings } from 'src/app/config';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router, RouterStateSnapshot } from '@angular/router';
import { navItems } from './vertical/sidebar/sidebar-data';
import { NavService } from '../../services/nav.service';
import { AppNavItemComponent } from './vertical/sidebar/nav-item/nav-item.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './vertical/sidebar/sidebar.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TablerIconsModule } from 'angular-tabler-icons';
import { HeaderComponent } from './vertical/header/header.component';
import { AppHorizontalHeaderComponent } from './horizontal/header/header.component';
import { AppHorizontalSidebarComponent } from './horizontal/sidebar/sidebar.component';
import { AppBreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { CustomizerComponent } from './shared/customizer/customizer.component';
import { BrandingComponent } from './vertical/sidebar/branding.component';
import { AuthService } from '../../services/auth.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { LocalStorageService } from '../../Shared/common/local-storage.service';
import { LoginComponent } from '../../components/auth/Pages/login/login.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { LoginapiService } from '../../components/auth/Pages/services/loginapi.service';
import { ToastrService } from 'ngx-toastr';
import { BaseEntityModel } from '../../Data/Models/Common/base-entity-model';
import { UserLicenseDetailsModel } from '../../Data/Models/Users/user-license-details-model';
import moment from 'moment';
import { UsersApiService } from '../../Shared/common/users-api.service';
import Swal from 'sweetalert2';
import { AuthConfigService } from '../../Configuration/auth-config.service';
import * as CryptoJS from 'crypto-js';
import { CharityDataShareServiceService } from '../../components/charity/charities/services/charity-data-share-service.service';

const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';
const BELOWMONITOR = 'screen and (max-width: 1023px)';

// for mobile app sidebar
interface apps {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface quicklinks {
  id: number;
  title: string;
  link: string; 
}

@Component({
  selector: 'app-full',
  imports: [
    RouterModule,
    AppNavItemComponent,
    MaterialModule,
    CommonModule,
    SidebarComponent,
    NgScrollbarModule,
    TablerIconsModule,
    HeaderComponent,
    AppHorizontalHeaderComponent,
    AppHorizontalSidebarComponent,
    AppBreadcrumbComponent,
    CustomizerComponent,
    BrandingComponent,
    LoginComponent,
    NgxSpinnerModule
  ],
  templateUrl: './full.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None,
})
export class FullComponent implements OnInit {
  navItems = navItems;
  centralUserID: any;

  @ViewChild('leftsidenav')
  public sidenav: MatSidenav;
  resView = false;
  @ViewChild('content', { static: true }) content!: MatSidenavContent;
  //get options from service
  options = this.settings.getOptions();
  private layoutChangesSubscription = Subscription.EMPTY;
  private isMobileScreen = false;
  private isContentWidthFixed = true;
  private isCollapsedWidthFixed = false;
  private htmlElement!: HTMLHtmlElement;
  state: RouterStateSnapshot;
    userName: string;
    currentUser: any;
    ShowRenew: boolean;
    leftDays: number;
    expiretoday: boolean;
    subEndDate: any;
    subStartDate: any;
    userLicenceDetails: UserLicenseDetailsModel;
    planId: any;
    pricingID: any;
    productID: any;
    TableRecordCnt: string;
    numberOfUsers: any;
    userCount: any;
    charityCount: any;
    userStatus: boolean;
    productName: number;
    countryName: any;
    city: any;
    postCode: any;
    countyName: any;
  noOfCharities: string | number;
  IsAdmin: boolean = false;

  get isOver(): boolean {
    return this.isMobileScreen;
  }

  get isTablet(): boolean {
    return this.resView;
  }

  // for mobile app sidebar
  apps: apps[] = [
    {
      id: 1,
      img: '/assets/images/svgs/icon-dd-chat.svg',
      title: 'Chat Application',
      subtitle: 'Messages & Emails',
      link: '/apps/chat',
    },
    {
      id: 2,
      img: '/assets/images/svgs/icon-dd-cart.svg',
      title: 'eCommerce App',
      subtitle: 'Buy a Product',
      link: '/apps/email/inbox',
    },
    {
      id: 3,
      img: '/assets/images/svgs/icon-dd-invoice.svg',
      title: 'Invoice App',
      subtitle: 'Get latest invoice',
      link: '/apps/invoice',
    },
    {
      id: 4,
      img: '/assets/images/svgs/icon-dd-date.svg',
      title: 'Calendar App',
      subtitle: 'Get Dates',
      link: '/apps/calendar',
    },
    {
      id: 5,
      img: '/assets/images/svgs/icon-dd-mobile.svg',
      title: 'Contact Application',
      subtitle: '2 Unsaved Contacts',
      link: '/apps/contacts',
    },
    {
      id: 6,
      img: '/assets/images/svgs/icon-dd-lifebuoy.svg',
      title: 'Tickets App',
      subtitle: 'Create new ticket',
      link: '/apps/tickets',
    },
    {
      id: 7,
      img: '/assets/images/svgs/icon-dd-message-box.svg',
      title: 'Email App',
      subtitle: 'Get new emails',
      link: '/apps/email/inbox',
    },
    {
      id: 8,
      img: '/assets/images/svgs/icon-dd-application.svg',
      title: 'Courses',
      subtitle: 'Create new course',
      link: '/apps/courses',
    },
  ];

  quicklinks: quicklinks[] = [
    {
      id: 1,
      title: 'Pricing Page',
      link: '/theme-pages/pricing',
    },
    {
      id: 2,
      title: 'Authentication Design',
      link: '/authentication/login',
    },
    {
      id: 3,
      title: 'Register Now',
      link: '/authentication/side-register',
    },
    {
      id: 4,
      title: '404 Error Page',
      link: '/authentication/error',
    },
    {
      id: 5,
      title: 'Notes App',
      link: '/apps/notes',
    },
    {
      id: 6,
      title: 'Employee App',
      link: '/apps/employee',
    },
    {
      id: 7,
      title: 'Todo Application',
      link: '/apps/todo',
    },
    {
      id: 8,
      title: 'Treeview',
      link: '/theme-pages/treeview',
    },
  ];

  constructor(
    private settings: CoreService,
    private mediaMatcher: MediaMatcher,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private navService: NavService,
    public authService: AuthService,
    private oauthService: OAuthService,
    private lsService: LocalStorageService,
    private userAPIService: UsersApiService,
    private spinner: NgxSpinnerService, private loginService: LoginapiService, private toastr: ToastrService, private authconfigService: AuthConfigService,
    private charityservice: CharityDataShareServiceService,
  ) {
    this.htmlElement = document.querySelector('html')!;
    this.layoutChangesSubscription = this.breakpointObserver
      .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW, BELOWMONITOR])
      .subscribe((state) => {
        // SidenavOpened must be reset true when layout changes
        this.options.sidenavOpened = true;
        this.isMobileScreen = state.breakpoints[BELOWMONITOR];
        if (this.options.sidenavCollapsed == false) {
          this.options.sidenavCollapsed = state.breakpoints[TABLET_VIEW];
        }
        this.isContentWidthFixed = state.breakpoints[MONITOR_VIEW];
        this.resView = state.breakpoints[BELOWMONITOR];
      });

    // Initialize project theme with options
    this.receiveOptions(this.options);

    // This is for scroll to top
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((e) => {
        this.content.scrollTo({ top: 0 });
        if (e.urlAfterRedirects.startsWith('/charity/notes')) {
          this.autoCollapseSidenav();
        } else {
          this.autoOpenSidenav();
        }
      });
  }

  autoCollapseSidenav() {
    this.isContentWidthFixed = false;
    this.options.sidenavCollapsed = true;  
    this.resetCollapsedState();
  }
  autoOpenSidenav() {
    this.isContentWidthFixed = false;
    this.options.sidenavCollapsed = false;
    this.resetCollapsedState();
  }

  year: any; nextyear: any;

  ngOnInit(): void {
    debugger

    debugger

    var curentdate = new Date();
    var y = curentdate.getFullYear();
    this.year = y
    this.nextyear = y;

    this.spinner.show();
    const storedValue = sessionStorage.getItem('id_token_claims_obj');
    if (storedValue) {
      var email = JSON.parse(storedValue);
    }
    debugger
    if (email) {
      var email = email.emails[0]
      this.logIn(email);              // for azure
    }
  
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      this.authService.userFullName = parsedUser.firstName + " " + parsedUser.lastName;
      this.authService.userEmail = parsedUser.emailID
      this.charityservice.setuserName(this.authService.userFullName)


    }
    
  }


  ngOnDestroy() {
    this.layoutChangesSubscription.unsubscribe();
  }

  toggleCollapsed() {
    this.isContentWidthFixed = false;
    this.options.sidenavCollapsed = !this.options.sidenavCollapsed;
    this.resetCollapsedState();
  }

  resetCollapsedState(timer = 400) {
    setTimeout(() => this.settings.setOptions(this.options), timer);
  }

  onSidenavClosedStart() {
    this.isContentWidthFixed = false;
  }

  onSidenavOpenedChange(isOpened: boolean) {
    this.isCollapsedWidthFixed = !this.isOver;
    this.options.sidenavOpened = isOpened;
    this.settings.setOptions(this.options);
  }

  receiveOptions(options: AppSettings): void {
    //this.options = options;

    this.toggleDarkTheme(options);
    this.toggleColorsTheme(options);
  }

  toggleDarkTheme(options: AppSettings) {
    if (options.theme === 'dark') {
      this.htmlElement.classList.add('dark-theme');
      this.htmlElement.classList.remove('light-theme');
    } else {
      this.htmlElement.classList.remove('dark-theme');
      this.htmlElement.classList.add('light-theme');
    }
  }

  toggleColorsTheme(options: AppSettings) {
    // Remove any existing theme class dynamically
    this.htmlElement.classList.forEach((className) => {
      if (className.endsWith('_theme')) {
        this.htmlElement.classList.remove(className);
      }
    });

    // Add the selected theme class
    this.htmlElement.classList.add(options.activeTheme);
  }
  logout() {
    debugger
    this.oauthService.logOut();
    this.authService.logOut();
  }
  async logIn(email: string) {
    debugger
    setTimeout(() => { this.spinner.hide();
    }, 2000, true);
    await  this.authService.logIn(email)
      .subscribe((res) => {
        debugger
        if (res.status == 0) {
          //Navigate to to the page based on returnUrl
          if (res.entity != null) {
            this.lsService.setCurrentUser(res.entity[0]);
            this.authService.currentUserSubject.next(res.entity[0]);
            this.authService.checkUserLicenseDetails();
            this.GetUserLicence();
            localStorage.setItem("CurrentuserID", res.entity[0].userID.toString());
            localStorage.setItem("CentralUserId", res.entity[0].centralUserID.toString());
            const currentUser = localStorage.getItem('currentUser');
            if (currentUser) {
              const parsedUser = JSON.parse(currentUser);
              this.centralUserID = parsedUser.centralUserID;
            }
          }
          this.authService.checkUserLicenseDetails()
          this.GetUserLicence();

        } else {
          this.toastr.error(res.message, '', {
            timeOut: 5000,
            positionClass: 'toast-top-center'
          });
          setTimeout(() => {
            this.oauthService.logOut();
            this.authService.logOut();
          }, 2000, true);
        }
        setTimeout(() => {
          this.spinner.hide();
        }, 2000, true);
      }, err => {
        this.toastr.error(err.statusText, '', {
          timeOut: 5000,
          positionClass: 'toast-top-center'
        });
        setTimeout(() => {
          this.oauthService.logOut();
          this.authService.logOut();
        }, 2000, true);
      })
  }

  GetUserLicence() {
    debugger
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      const parsedUser = JSON.parse(currentUser);
      this.currentUser = parsedUser.userID;
    }
    this.userAPIService.getUserLicenseDetails(this.currentUser).subscribe((data: BaseEntityModel<UserLicenseDetailsModel>) => {
      debugger
      if (data.status == 0) {
        if (data.entity != null && data.entity.length > 0) {
          this.userLicenceDetails = data.entity[0]
          this.subStartDate = data.entity[0].tuCreatedDate
          this.subStartDate = moment(this.subStartDate).format("DD/MM/YYYY");// for time HH:mm:ss
          this.subEndDate = data.entity[0].tuEndDate
          this.subEndDate = moment(this.subEndDate).format("DD/MM/YYYY");// for time HH:mm:ss
          var today = new Date();
          var licenseEndDate = moment(data.entity[0].tuEndDate, 'YYYY-MM-DD HH:mm:ss').format("DD/MM/YYYY");
          var today1 = moment(today, 'YYYY-MM-DD HH:mm:ss').format("DD/MM/YYYY");
          // licenseEndDate = moment(licenseEndDate, "DD/MM/YYYY")
          var diffDays = (moment(licenseEndDate, "DD/MM/YYYY").diff(moment(today1, "DD/MM/YYYY"), "days"));
          //(diffDays < 0) ? this.isLicenceExpired = true : this.isLicenceExpired = false;
          this.userCount = data.entity[0].noOfUsersCreated
          this.charityCount = data.entity[0].noofCharitiescreated
          this.userStatus = data.entity[0].userStatus
          this.productID = data.entity[0].productID
          this.productName = data.entity[0].productName
          this.centralUserID = data.entity[0].central_User_ID
          this.TableRecordCnt = data.entity[0].totalNoofCharitiescreated
          // this.numberOfUsers = data.entity[0].number_Of_Users;
          this.planId = data.entity[0].planId;
          this.pricingID = data.entity[0].pricingId;
          this.countryName = data.entity[0].countryName
          this.city = data.entity[0].city
          this.postCode = data.entity[0].postCode;
          this.countyName = data.entity[0].countyName;
          // this.noOfCharities = data.entity[0].noOfCharities;
          this.numberOfUsers = data.entity[0].number_Of_Users >= 99999 ? 'Unlimited' : data.entity[0].number_Of_Users;
          this.noOfCharities = data.entity[0].noOfCharities >= 99999 ? 'Unlimited' : data.entity[0].noOfCharities;
          this.IsAdmin = data.entity[0].isAdmin;
          var date = new Date();
          if (diffDays >= 0 && diffDays <= 30) {
            this.expiretoday = diffDays == 0;
            this.leftDays = diffDays
            this.ShowRenew = true;
          }
          else if (diffDays < 0) {
            this.ShowRenew = true;
          }
        }
      }

    })
  }

  Upgrade(Type: any) {
    debugger
    this.userAPIService.getUserLicenseDetails(this.currentUser).subscribe((data: BaseEntityModel<UserLicenseDetailsModel>) => {
      debugger
      if (data.entity[0].userStatus == true) {
        var centralUserID = (this.centralUserID).toString();

        var subscriptionURL = this.authconfigService.getSubscriptionAPIUrl();
        var prodId = (this.productID).toString();
        prodId = prodId.split('+').join('vkanslab');

        var encryptedDataProdID = CryptoJS.AES.encrypt(prodId, "My Secret Passphrase");
        var ProductID = encryptedDataProdID.toString();
        ProductID = ProductID.split('+').join('vkanslab');

        var encryptedData1 = CryptoJS.AES.encrypt(centralUserID, "My Secret Passphrase");
        var centralUserId = encryptedData1.toString();
        centralUserId = centralUserId.split('+').join('vkanslab');

        var name = ''
        if (Type == 'Upgrade') {
          var encryptedData2 = CryptoJS.AES.encrypt("Upgrade", "My Secret Passphrase");
          name = encryptedData2.toString();
          name = name.split('+').join('vkanslab');
        } else if (Type == 'Renew') {
          var encryptedData2 = CryptoJS.AES.encrypt("Renew", "My Secret Passphrase");
          name = encryptedData2.toString();
          name = name.split('+').join('vkanslab');
        }



        var encryptedData3 = CryptoJS.AES.encrypt(this.TableRecordCnt + "", "My Secret Passphrase");
        var numberOfCharitiesCreated = encryptedData3.toString();
        numberOfCharitiesCreated = numberOfCharitiesCreated.split('+').join('vkanslab');


        var encryptedData4 = CryptoJS.AES.encrypt("Annually", "My Secret Passphrase");
        var subType = encryptedData4.toString();
        subType = subType.split('+').join('vkanslab');


        var numOfUsers = this.numberOfUsers + "";
        var encryptedData5 = CryptoJS.AES.encrypt(numOfUsers, "My Secret Passphrase");
        var numberOfUsers = encryptedData5.toString();
        numberOfUsers = numberOfUsers.split('+').join('vkanslab');

        var StatusFrom = ''
        var PlanId = ''
        var PricingID = ''
        //upgrade from users
        if (Type == 'Upgrade' || Type == 'Renew') {
          var encryptedData6 = CryptoJS.AES.encrypt("FromCompanies", "My Secret Passphrase");
          StatusFrom = encryptedData6.toString();
          StatusFrom = StatusFrom.split('+').join('vkanslab');
          var encryptedDataPlanId = CryptoJS.AES.encrypt(this.planId + "", "My Secret Passphrase");
          PlanId = encryptedDataPlanId.toString();
          PlanId = PlanId.split('+').join('vkanslab');
          var encryptedDataPricingID = CryptoJS.AES.encrypt(this.pricingID + "", "My Secret Passphrase");
          PricingID = encryptedDataPricingID.toString();
          PricingID = PricingID.split('+').join('vkanslab');
        }
        debugger;
        var URL = "";
        //subscriptionURL ='https://subscriptions.dev.acuitysoft.com'   //for testing
        if (Type == 'Renew' || Type == 'Upgrade') {
          URL = subscriptionURL + "/payment/plandetails/CustomerPlans?ProductName=" + ProductID + "&centralUserId=" + centralUserId + "&regType=" + name + "&numberOfCompanies=" + numberOfCharitiesCreated + "&subType=" + subType + "&RegUsers=" + numberOfUsers + "&StatusFrom=" + StatusFrom + "&PlanId=" + PlanId + "&PricingId=" + PricingID;
        }
        else {
          URL = subscriptionURL + "/payment/plandetails/CustomerPlans?ProductName=" + ProductID + "&centralUserId=" + centralUserId + "&regType=" + name + "&numberOfCompanies=" + numberOfCharitiesCreated + "&subType=" + subType + "&RegUsers=" + numberOfUsers + "&StatusFrom=" + StatusFrom + "&PlanId=" + PlanId + "&PricingId=" + PricingID;
        }
        window.open(URL, '_self');
      } else {
        Swal.fire('', "This software license is deactivated .please contact Andica Sales.");
        return;
      }
    });
  }
}
